import { render, staticRenderFns } from "./PortalGroups_DELETE.vue?vue&type=template&id=b8fa130a&scoped=true"
import script from "./PortalGroups_DELETE.vue?vue&type=script&lang=js"
export * from "./PortalGroups_DELETE.vue?vue&type=script&lang=js"
import style0 from "./PortalGroups_DELETE.vue?vue&type=style&index=0&id=b8fa130a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fa130a",
  null
  
)

export default component.exports